<template>
  <button ref="deleteSubject" @click="destroySubject" class="btn btn-danger btn-sm">Delete</button>
</template>

<script>
import axios from "axios";
export default {
  props: ["endpoint"],

  methods: {
    async destroySubject() {
      let q = window.confirm("Are you sure?");
      if (q == true) {
        let response = await axios.delete(
          `/api/subjects/${this.endpoint}/delete`
        );
        if (response.status == 200) {
          this.$toasted.show(response.data.message, {
            type: "success",
            duration: 2000,
          });
          this.$refs.deleteSubject.parentNode.parentNode.remove();
        }
      }
    },
  },
};
</script>
